import { useRef, useEffect } from "@/common/hooks";
import { Modal } from "bootstrap";
import { Heading, Button, MaterialIcon } from "@/common/components";

const SuccessPopup = ({ showModal, body = "", buttonText = "", click }) => {
  const modalRef = useRef();

  useEffect(() => {
    if (showModal) {
      showModalFunction();
    }
  }, [showModal]);

  const showModalFunction = () => {
    const modalEle = modalRef.current;
    const bsModal = new Modal(modalEle, {
      backdrop: "static",
      keyboard: false,
    });
    bsModal.show();
  };

  const hideModal = () => {
    const modalEle = modalRef.current;
    const bsModal = Modal.getInstance(modalEle);
    bsModal.hide();
    click();
  };

  return (
    <div className="successPopup">
      <div className="modal fade" ref={modalRef} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center pt-5">
              <MaterialIcon
                iconName="check_circle"
                iconClassName="display-3 primary-color"
              />
              <Heading text={"Success"} wrapperClassNames="h4" />
              <div dangerouslySetInnerHTML={{ __html: body }}></div>
            </div>
            <div className="modal-footer justify-content-center border-top-0">
              <Button
                type="primary"
                text={buttonText}
                wrapperClassName="col-12"
                click={() => hideModal()}
                ariaLabel={buttonText}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup;
